import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Project } from '../../organisms/Project';
import { FullLoader } from '@sc/shared-ui';
import z from 'zod';

export const projectsValidateSearch = z.object({
  history: z.boolean().optional(),
  modal: z.string().optional()
}).optional();

export const Route = createFileRoute('/_authenticated/kb_/$uuid')({
  component: RouteComponent,
  validateSearch: projectsValidateSearch
});

function RouteComponent() {
  const params = Route.useParams();
  const search = Route.useSearch();

  return (
    <Suspense fallback={<FullLoader className="size-8" />}>
      <Project openModal={search?.modal} showHistory={!!search?.history} uuid={params.uuid} />
    </Suspense>
  );
}
